import { Box, Button, Typography, Radio, RadioGroup, FormControlLabel, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import axios from 'axios';
import { AuthContext } from '../../context/AuthContext';
import { useContext, useState } from "react";
import jsPDF from 'jspdf';

const RegisterSupplier = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { base_url, currentuser } = useContext(AuthContext);
  const [images, setImages] = useState([]);
  const [pdfUrl, setPdfUrl] = useState('');
  const [uploadType, setUploadType] = useState('images');
  const [pdfFile, setPdfFile] = useState(null); // State for the uploaded PDF file

  const handleImageChange = (event) => {
    const files = Array.from(event.target.files);
    setImages((prevImages) => [...prevImages, ...files]);
  };

  const removeImage = (index) => {
    setImages((prevImages) => prevImages.filter((_, i) => i !== index));
  };

  const uploadPDF = async (file) => { // Accept a File object directly
    const formData = new FormData();
    formData.append('pdf', file, file.name); // Use the file directly

    try {
      const response = await axios.post(`${base_url}/upload-pdf`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      alert("PDF uploaded successfully!");
      setImages([]);
      const uploadedFileUrl = `${base_url}/uploads/${response.data.file.filename}`;
      setPdfUrl(uploadedFileUrl);
      console.log('PDF URL:', uploadedFileUrl);
    } catch (error) {
      console.error("Error uploading PDF", error);
      alert("Failed to upload PDF.");
    }
  };

  const generatePDF = async () => {
    const pdf = new jsPDF();

    for (let index = 0; index < images.length; index++) {
      const imgData = await getImageData(images[index]);

      const pdfPageWidth = pdf.internal.pageSize.getWidth();
      const img = new Image();
      img.src = imgData;

      await new Promise((resolve) => {
        img.onload = resolve;
      });

      pdf.addImage(imgData, 'PNG', 10, 10, pdfPageWidth - 20, (pdfPageWidth - 20) * (img.height / img.width));

      if (index < images.length - 1) {
        pdf.addPage();
      }
    }

    const pdfBlob = pdf.output('blob');
    const pdfFile = new File([pdfBlob], 'generated.pdf', { type: 'application/pdf' }); // Create a valid File object
    await uploadPDF(pdfFile); // Pass the File object to uploadPDF
  };

  const getImageData = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(file);
    });
  };

  const handleUpload = (event) => {
    const file = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      setPdfFile(file); // Set the selected PDF file
    } else {
      alert("Please select a valid PDF file.");
    }
  };

  const submitPDF = async () => {
    if (pdfFile) {
      await uploadPDF(pdfFile); // Use the pdfFile directly
    } else {
      alert("No PDF file selected.");
    }
  };

  return (
    <Box m="20px">
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header subtitle="Upload your company documents" />
      </Box>
      <Box>
        <RadioGroup
          value={uploadType}
          onChange={(e) => {
            setUploadType(e.target.value);
            setPdfFile(null); // Reset PDF file when changing upload type
            setImages([]); // Reset images when changing upload type
          }}
          row
        >
          <FormControlLabel value="images" control={<Radio />} label="Upload Images" />
          <FormControlLabel value="pdf" control={<Radio />} label="Upload PDF" />
        </RadioGroup>
      </Box>
      <Box>
        {uploadType === 'images' ? (
          <>
            <input type="file" onChange={handleImageChange} multiple accept="image/*" />
            <Button variant="contained" onClick={generatePDF} disabled={images.length === 0}>
              Generate and Upload PDF
            </Button>
            <Box mt="20px">
              {images.length > 0 && (
                <Box>
                  <Typography variant="h6">Selected Images:</Typography>
                  <Box display="flex" flexWrap="wrap" mt={2}>
                    {images.map((image, index) => (
                      <Box key={index} display="flex" flexDirection="column" alignItems="center" m={1}>
                        <img
                          src={URL.createObjectURL(image)}
                          alt={`Selected ${index}`}
                          style={{
                            width: '150px',
                            height: 'auto',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            boxShadow: '2px 2px 5px rgba(0,0,0,0.2)',
                          }}
                        />
                        <Button variant="outlined" color="error" onClick={() => removeImage(index)} style={{ marginTop: '5px' }}>
                          Remove
                        </Button>
                      </Box>
                    ))}
                  </Box>
                </Box>
              )}
            </Box>
          </>
        ) : (
          <Box>
            <input type="file" onChange={handleUpload} accept="application/pdf" />
            <Button variant="contained" onClick={submitPDF} disabled={!pdfFile}>
              Upload PDF
            </Button>
          </Box>
        )}
      </Box>
      {pdfUrl && (
        <Box mt="20px">
          <Typography variant="h6">Uploaded PDF:</Typography>
          <Box sx={{ border: '1px solid #ccc', borderRadius: '4px', overflow: 'hidden' }}>
            <iframe
              src={pdfUrl}
              style={{ width: '100%', height: '500px', border: 'none' }}
              title="Uploaded PDF"
              onLoad={() => console.log("PDF Loaded")}
              onError={() => console.error("Error loading PDF")}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default RegisterSupplier;